var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiscover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 155,
    viewBox: "0 0 241 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3617_14543)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39673 8.73134V146.409C3.39673 149.307 5.76775 151.678 8.66566 151.678H154.826C195.739 151.678 228.933 118.51 228.933 77.57C228.933 36.6567 195.766 3.4624 154.826 3.4624H8.66566C5.76775 3.4624 3.39673 5.83342 3.39673 8.73134Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.232 60.8936H11.906V93.5083H21.2057C26.1321 93.5083 29.715 92.3491 32.85 89.741C36.5646 86.6587 38.7776 82.022 38.7776 77.2273C38.7776 67.6115 31.5855 60.8936 21.2584 60.8936H21.232ZM28.6612 85.3941C26.659 87.1855 24.0772 87.9759 19.9675 87.9759H18.2551V66.3996H19.9675C24.0772 66.3996 26.58 67.1373 28.6612 69.0341C30.8742 70.9836 32.1914 74.0396 32.1914 77.1482C32.1914 80.2569 30.8742 83.4183 28.6612 85.3678V85.3941Z",
    fill: "#261F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9982 60.8936H41.6492V93.5083H47.9982V60.8936Z",
    fill: "#261F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5681 73.4078C59.7481 71.9852 58.6416 71.0631 58.6416 69.298C58.6416 67.2431 60.6438 65.6888 63.3837 65.6888C65.2805 65.6888 66.8611 66.4791 68.5208 68.3233L71.8403 63.9764C69.1005 61.579 65.8337 60.3672 62.2509 60.3672C56.4814 60.3672 52.0817 64.3716 52.0817 69.7195C52.0817 74.2245 54.1367 76.5165 60.1169 78.6504C62.5933 79.5198 63.8842 80.1257 64.5165 80.4945C65.781 81.3112 66.4132 82.4967 66.4132 83.8666C66.4132 86.5011 64.3056 88.477 61.4604 88.477C58.4308 88.477 55.9808 86.949 54.5055 84.1301L50.3958 88.0818C53.32 92.376 56.8502 94.2991 61.6976 94.2991C68.3101 94.2991 72.9468 89.8996 72.9468 83.6032C72.9468 78.4133 70.8129 76.0686 63.5681 73.4341V73.4078Z",
    fill: "#261F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9485 77.2271C74.9485 86.8166 82.4831 94.2458 92.1516 94.2458C94.8914 94.2458 97.2361 93.7189 100.134 92.349V84.8671C97.5786 87.4225 95.3393 88.45 92.4413 88.45C86.0396 88.45 81.482 83.8133 81.482 77.2008C81.482 70.9308 86.1713 66.0043 92.1516 66.0043C95.1812 66.0043 97.4732 67.0844 100.134 69.6662V62.1843C97.3415 60.7617 95.0495 60.1821 92.3096 60.1821C82.6675 60.1821 74.9485 67.7694 74.9485 77.2535V77.2271Z",
    fill: "#261F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.584 82.8123L141.891 60.8936H134.936L148.767 94.3513H152.191L166.286 60.8936H159.383L150.584 82.8123Z",
    fill: "#261F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.157 93.5083H187.203V88.0022H175.533V79.2031H186.782V73.6707H175.533V66.4259H187.203V60.8936H169.157V93.5083Z",
    fill: "#261F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.389 70.5362C212.389 64.4243 208.173 60.9204 200.85 60.9204H191.418V93.5351H197.767V80.4418H198.61L207.409 93.5351H215.234L204.959 79.7832C209.754 78.8085 212.389 75.5417 212.389 70.5362ZM199.638 75.9105H197.767V66.0313H199.717C203.668 66.0313 205.829 67.691 205.829 70.8787C205.829 74.0664 203.668 75.9105 199.611 75.9105H199.638Z",
    fill: "#261F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.473 62.6063C217.473 62.0267 217.078 61.7104 216.393 61.7104H215.471V64.5821H216.156V63.4755L216.973 64.5821H217.816L216.867 63.3965C217.263 63.2911 217.5 63.0014 217.5 62.6063H217.473ZM216.262 63.0014H216.156V62.2374H216.288C216.63 62.2374 216.815 62.3692 216.815 62.6063C216.815 62.8434 216.63 63.0014 216.288 63.0014H216.262Z",
    fill: "#261F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.499 60.6567C215.102 60.6567 213.996 61.7632 213.996 63.1595C213.996 64.5557 215.129 65.6622 216.499 65.6622C217.869 65.6622 218.975 64.5294 218.975 63.1595C218.975 61.7896 217.869 60.6567 216.499 60.6567ZM216.499 65.2144C215.392 65.2144 214.496 64.2923 214.496 63.1595C214.496 62.0267 215.392 61.1046 216.499 61.1046C217.605 61.1046 218.474 62.053 218.474 63.1595C218.474 64.266 217.579 65.2144 216.499 65.2144Z",
    fill: "#261F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.753 77.1747C136.753 86.7114 129.034 94.4568 119.471 94.4568C109.908 94.4568 102.189 86.7378 102.189 77.1747C102.189 67.6116 109.908 59.8926 119.471 59.8926C129.034 59.8926 136.753 67.6116 136.753 77.1747Z",
    fill: "url(#paint0_linear_3617_14543)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65,
    d: "M136.753 77.1747C136.753 86.7114 129.034 94.4568 119.471 94.4568C109.908 94.4568 102.189 86.7378 102.189 77.1747C102.189 67.6116 109.908 59.8926 119.471 59.8926C129.034 59.8926 136.753 67.6116 136.753 77.1747Z",
    fill: "url(#paint1_linear_3617_14543)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3617_14543",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 59,
    width: 35,
    height: 36
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.753 77.1747C136.753 86.7114 129.008 94.4568 119.471 94.4568C109.935 94.4568 102.189 86.7378 102.189 77.1747C102.189 67.6116 109.908 59.8926 119.471 59.8926C129.034 59.8926 136.753 67.6116 136.753 77.1747Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3617_14543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.55 59.6552C129.271 59.6552 137.175 67.5323 137.175 77.2535C137.175 86.9747 129.271 94.8781 119.55 94.8781C109.829 94.8781 101.926 87.001 101.926 77.2535C101.926 67.5323 109.803 59.6289 119.55 59.6289V59.6552Z",
    fill: "#020000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.576 59.6816C129.298 59.6816 137.201 67.5323 137.201 77.2535C137.201 86.9747 129.298 94.9045 119.576 94.9045C109.855 94.9045 101.952 87.0274 101.952 77.3062C101.952 67.585 109.855 59.6816 119.576 59.6816Z",
    fill: "#030100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.577 59.7075C129.298 59.7075 137.228 67.5582 137.228 77.2794C137.228 87.0006 129.324 94.9304 119.577 94.9304C109.829 94.9304 101.952 87.0533 101.978 77.3321C101.978 67.6109 109.882 59.7075 119.577 59.7339V59.7075Z",
    fill: "#050100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.603 59.7344C129.324 59.7344 137.254 67.5588 137.254 77.28C137.254 87.0012 129.324 94.9309 119.603 94.9309C109.882 94.9309 101.978 87.0539 102.005 77.3327C102.005 67.6115 109.908 59.7081 119.603 59.7344Z",
    fill: "#070200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.629 59.7603C129.35 59.7603 137.28 67.5583 137.28 77.2795C137.28 87.0007 129.35 94.9568 119.629 94.9568C109.908 94.9568 102.005 87.0797 102.031 77.3586C102.031 67.6374 109.934 59.734 119.629 59.7603Z",
    fill: "#080200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.656 59.7872C129.377 59.7872 137.307 67.5852 137.307 77.3064C137.307 87.0276 129.377 94.9837 119.656 94.9837C109.934 94.9837 102.031 87.1066 102.057 77.3854C102.057 67.6642 109.961 59.7608 119.656 59.7872Z",
    fill: "#0A0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.656 59.8131C129.377 59.8131 137.333 67.5847 137.333 77.3059C137.333 87.0271 129.377 95.0095 119.656 95.0095C109.934 95.0095 102.031 87.1325 102.057 77.4113C102.057 67.6901 109.961 59.7867 119.656 59.8131Z",
    fill: "#0C0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.682 59.8394C129.403 59.8394 137.359 67.6111 137.359 77.3059C137.359 87.0008 129.403 95.0095 119.682 95.0095C109.961 95.0095 102.057 87.1325 102.084 77.4113C102.084 67.6901 109.987 59.7867 119.682 59.8131V59.8394Z",
    fill: "#0E0400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.708 59.8658C129.43 59.8921 137.386 67.6111 137.386 77.3323C137.386 87.0535 129.403 95.0623 119.708 95.0623C110.014 95.0623 102.084 87.1852 102.11 77.464C102.11 67.7428 110.014 59.8394 119.708 59.8658Z",
    fill: "#0F0400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.708 59.919C129.43 59.9453 137.386 67.638 137.386 77.3592C137.386 87.0803 129.403 95.0891 119.708 95.0891C110.014 95.0891 102.084 87.2121 102.11 77.4909C102.137 67.7697 110.014 59.8663 119.708 59.8926V59.919Z",
    fill: "#110500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.734 59.9453C129.455 59.9717 137.438 67.6643 137.438 77.3591C137.438 87.054 129.455 95.1155 119.734 95.1155C110.013 95.1155 102.11 87.2384 102.162 77.5436C102.189 67.8224 110.066 59.919 119.734 59.9717V59.9453Z",
    fill: "#130500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.761 59.9712C129.455 59.9975 137.464 67.6638 137.464 77.385C137.464 87.1062 129.455 95.1413 119.761 95.1413C110.066 95.1413 102.136 87.2643 102.189 77.5694C102.215 67.8482 110.092 59.9449 119.761 59.9975V59.9712Z",
    fill: "#140600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.787 59.9983C129.482 60.0247 137.491 67.6646 137.491 77.3858C137.491 87.107 129.482 95.1421 119.787 95.1421C110.092 95.1421 102.162 87.265 102.215 77.5702C102.241 67.849 110.145 59.9456 119.787 59.9983Z",
    fill: "#160600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.787 60.0242C129.482 60.0769 137.517 67.6905 137.517 77.3853C137.517 87.0802 129.508 95.168 119.787 95.168C110.066 95.168 102.189 87.2909 102.215 77.5961C102.241 67.8749 110.145 59.9715 119.787 60.0242Z",
    fill: "#180600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.813 60.0501C129.508 60.1028 137.543 67.69 137.543 77.4112C137.543 87.1324 129.508 95.1939 119.813 95.1939C110.118 95.1939 102.215 87.3168 102.241 77.622C102.294 67.9008 110.171 59.9974 119.813 60.0501Z",
    fill: "#190700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.84 60.0769C129.534 60.1296 137.57 67.7169 137.57 77.4117C137.57 87.1066 129.534 95.2207 119.84 95.2207C110.145 95.2207 102.241 87.3437 102.268 77.6488C102.32 67.9276 110.197 60.0242 119.84 60.0769Z",
    fill: "#1B0700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.84 60.1033C129.534 60.156 137.57 67.7169 137.57 77.4117C137.57 87.1066 129.534 95.2207 119.84 95.2207C110.145 95.2207 102.241 87.37 102.268 77.6488C102.32 67.9276 110.197 60.0242 119.84 60.0769V60.1033Z",
    fill: "#1D0800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.866 60.1297C129.561 60.1823 137.622 67.7169 137.622 77.4381C137.622 87.1593 129.561 95.2735 119.866 95.2735C110.171 95.2735 102.268 87.4228 102.294 77.7016C102.347 67.954 110.224 60.077 119.866 60.1297Z",
    fill: "#1F0800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.892 60.1821C129.587 60.2348 137.649 67.7694 137.649 77.4642C137.649 87.1591 129.587 95.2996 119.892 95.2996C110.198 95.2996 102.294 87.4489 102.347 77.754C102.4 68.0065 110.277 60.1294 119.892 60.2085V60.1821Z",
    fill: "#200900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.919 60.209C129.614 60.2617 137.675 67.7699 137.675 77.4647C137.675 87.1596 129.614 95.3264 119.919 95.3264C110.224 95.3264 102.321 87.4757 102.373 77.7809C102.426 68.0333 110.303 60.1563 119.919 60.2353V60.209Z",
    fill: "#220900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.919 60.2355C129.614 60.2881 137.675 67.7964 137.675 77.4649C137.675 87.1334 129.587 95.3266 119.919 95.3266C110.25 95.3266 102.321 87.4759 102.373 77.781C102.426 68.0335 110.303 60.1564 119.919 60.2355Z",
    fill: "#240A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.945 60.2613C129.64 60.3404 137.728 67.7959 137.728 77.4908C137.728 87.1856 129.64 95.3524 119.945 95.3524C110.25 95.3524 102.347 87.5017 102.4 77.8069C102.452 68.0594 110.329 60.1823 119.945 60.2613Z",
    fill: "#250A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.972 60.2882C129.666 60.3672 137.754 67.7964 137.754 77.4913C137.754 87.1861 129.666 95.3793 119.972 95.3793C110.277 95.3793 102.373 87.5286 102.426 77.8337C102.479 68.0862 110.382 60.2092 119.972 60.2882Z",
    fill: "#270B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.972 60.3142C129.666 60.3932 137.754 67.8224 137.754 77.4909C137.754 87.1594 129.64 95.379 119.972 95.379C110.303 95.379 102.373 87.5282 102.426 77.8334C102.479 68.0859 110.382 60.2352 119.972 60.2879V60.3142Z",
    fill: "#290B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.998 60.3406C129.693 60.4196 137.807 67.8225 137.807 77.5173C137.807 87.2122 129.693 95.4317 119.998 95.4317C110.303 95.4317 102.4 87.581 102.452 77.8862C102.531 68.1386 110.408 60.2879 119.998 60.3406Z",
    fill: "#2A0C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.024 60.3669C129.719 60.446 137.833 67.8225 137.833 77.5173C137.833 87.2122 129.719 95.4317 120.024 95.4317C110.33 95.4317 102.426 87.581 102.479 77.8862C102.558 68.1386 110.435 60.2879 120.024 60.3406V60.3669Z",
    fill: "#2C0C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.051 60.3933C129.719 60.4724 137.86 67.8489 137.86 77.5174C137.86 87.1859 129.719 95.4581 120.051 95.4581C110.382 95.4581 102.453 87.6074 102.505 77.9389C102.584 68.1913 110.461 60.3406 120.051 60.3933Z",
    fill: "#2E0D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.051 60.4189C129.719 60.498 137.86 67.8481 137.86 77.543C137.86 87.2378 129.719 95.4837 120.051 95.4837C110.382 95.4837 102.452 87.633 102.531 77.9645C102.61 68.217 110.487 60.3663 120.051 60.4453V60.4189Z",
    fill: "#300D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.077 60.4717C129.745 60.5507 137.912 67.9009 137.912 77.5694C137.912 87.2379 129.772 95.5364 120.077 95.5364C110.382 95.5364 102.479 87.6857 102.558 78.0172C102.637 68.2697 110.514 60.419 120.077 60.498V60.4717Z",
    fill: "#310D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.103 60.4977C129.772 60.5767 137.939 67.9005 137.939 77.569C137.939 87.2375 129.772 95.5361 120.103 95.5361C110.435 95.5361 102.505 87.6854 102.584 78.0169C102.663 68.2693 110.54 60.4186 120.103 60.4977Z",
    fill: "#330E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.103 60.525C129.772 60.6304 137.939 67.9015 137.939 77.5964C137.939 87.2912 129.772 95.5634 120.103 95.5634C110.435 95.5634 102.505 87.7127 102.584 78.0442C102.663 68.2967 110.54 60.446 120.103 60.525Z",
    fill: "#350E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13 60.5504C129.798 60.6558 137.991 67.9269 137.991 77.5954C137.991 87.2639 129.825 95.5888 120.13 95.5888C110.435 95.5888 102.531 87.7381 102.61 78.0696C102.689 68.3221 110.567 60.4714 120.13 60.5504Z",
    fill: "#360F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.156 60.5767C129.825 60.6821 138.018 67.9269 138.018 77.5954C138.018 87.2639 129.825 95.5888 120.156 95.5888C110.488 95.5888 102.558 87.7381 102.637 78.0696C102.716 68.3221 110.593 60.4714 120.156 60.5504V60.5767Z",
    fill: "#380F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.182 60.6031C129.851 60.7085 138.044 67.9533 138.044 77.6218C138.044 87.2903 129.851 95.6416 120.182 95.6416C110.514 95.6416 102.584 87.7908 102.663 78.1223C102.742 68.3748 110.646 60.5241 120.182 60.6031Z",
    fill: "#3A1000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.182 60.6295C129.851 60.7349 138.044 67.9533 138.044 77.6218C138.044 87.2903 129.851 95.6416 120.182 95.6416C110.514 95.6416 102.584 87.7908 102.663 78.1223C102.769 68.3748 110.646 60.5241 120.182 60.6031V60.6295Z",
    fill: "#3B1000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.209 60.6567C129.877 60.7621 138.097 67.9542 138.097 77.6227C138.097 87.2912 129.877 95.6688 120.209 95.6688C110.54 95.6688 102.61 87.8181 102.716 78.176C102.821 68.4284 110.698 60.5777 120.209 60.6831V60.6567Z",
    fill: "#3D1100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.235 60.6826C129.903 60.788 138.123 67.9801 138.123 77.6486C138.123 87.3171 129.903 95.6947 120.235 95.6947C110.566 95.6947 102.637 87.8703 102.742 78.2018C102.847 68.4543 110.724 60.6036 120.235 60.7089V60.6826Z",
    fill: "#3F1100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.235 60.7091C129.903 60.8144 138.123 67.9802 138.123 77.6487C138.123 87.3172 129.903 95.6948 120.235 95.6948C110.566 95.6948 102.637 87.8704 102.742 78.2019C102.847 68.4544 110.724 60.6037 120.235 60.7091Z",
    fill: "#411200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.261 60.7618C129.93 60.8672 138.149 68.0066 138.149 77.6751C138.149 87.3436 129.903 95.7475 120.261 95.7475C110.619 95.7475 102.663 87.9231 102.768 78.2547C102.874 68.5071 110.751 60.6564 120.261 60.7618Z",
    fill: "#421200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.288 60.7877C129.956 60.9194 138.202 68.0325 138.202 77.701C138.202 87.3695 129.956 95.7734 120.288 95.7734C110.619 95.7734 102.689 87.949 102.795 78.2805C102.9 68.533 110.777 60.6823 120.288 60.7877Z",
    fill: "#441300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.314 60.8145C129.982 60.9462 138.228 68.033 138.228 77.7015C138.228 87.37 129.982 95.8002 120.314 95.8002C110.645 95.8002 102.716 87.9759 102.821 78.3074C102.926 68.5599 110.804 60.7091 120.314 60.8145Z",
    fill: "#461300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.314 60.8409C129.956 60.9726 138.228 68.0593 138.228 77.7015C138.228 87.3436 129.956 95.8002 120.314 95.8002C110.672 95.8002 102.716 87.9759 102.821 78.3074C102.926 68.5599 110.804 60.7091 120.314 60.8145V60.8409Z",
    fill: "#471300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.34 60.8673C129.982 60.999 138.281 68.0593 138.281 77.7278C138.281 87.3963 130.009 95.853 120.34 95.853C110.672 95.853 102.742 88.0286 102.847 78.3601C102.953 68.6126 110.83 60.7619 120.34 60.8673Z",
    fill: "#491400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.367 60.8936C130.009 61.0253 138.307 68.0593 138.307 77.7278C138.307 87.3963 130.035 95.853 120.367 95.853C110.698 95.853 102.768 88.0286 102.874 78.3864C103.006 68.6389 110.856 60.7882 120.367 60.9199V60.8936Z",
    fill: "#4B1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.367 60.9204C130.009 61.0521 138.308 68.0862 138.308 77.7283C138.308 87.3705 130.009 95.8798 120.367 95.8798C110.725 95.8798 102.769 88.0554 102.9 78.4133C103.032 68.6657 110.909 60.815 120.367 60.9468V60.9204Z",
    fill: "#4C1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.393 60.9465C130.035 61.0782 138.334 68.0859 138.334 77.728C138.334 87.3702 130.035 95.8795 120.393 95.8795C110.751 95.8795 102.795 88.0551 102.927 78.413C103.058 68.6654 110.935 60.8147 120.393 60.9465Z",
    fill: "#4E1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42 60.9723C130.062 61.1041 138.387 68.1117 138.387 77.7539C138.387 87.3961 130.088 95.9054 120.42 95.9054C110.751 95.9054 102.821 88.081 102.953 78.4389C103.085 68.6913 110.962 60.8406 120.42 60.9723Z",
    fill: "#501600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.446 61.0251C130.088 61.1568 138.413 68.1381 138.413 77.7803C138.413 87.4224 130.088 95.9581 120.446 95.9581C110.804 95.9581 102.848 88.1337 102.979 78.4916C103.111 68.7441 110.988 60.8933 120.446 61.0251Z",
    fill: "#521600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.446 61.0514C130.088 61.2095 138.413 68.1381 138.413 77.7803C138.413 87.4224 130.088 95.9581 120.446 95.9581C110.804 95.9581 102.848 88.1337 102.979 78.4916C103.111 68.7441 110.988 60.8933 120.446 61.0251V61.0514Z",
    fill: "#531700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 61.0778C130.114 61.2359 138.439 68.1645 138.439 77.8067C138.439 87.4488 130.114 96.0108 120.472 96.0108C110.83 96.0108 102.874 88.1865 103.006 78.5443C103.137 68.7968 111.015 60.9461 120.472 61.0778Z",
    fill: "#551700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.499 61.1042C130.141 61.2622 138.492 68.1645 138.492 77.8067C138.492 87.4488 130.141 96.0108 120.499 96.0108C110.856 96.0108 102.9 88.1865 103.032 78.5443C103.164 68.7968 111.041 60.9461 120.499 61.0778V61.1042Z",
    fill: "#571800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.499 61.131C130.141 61.2891 138.492 68.165 138.492 77.8072C138.492 87.4493 130.141 96.0377 120.499 96.0377C110.856 96.0377 102.9 88.2133 103.032 78.5712C103.164 68.8236 111.041 60.9729 120.499 61.1047V61.131Z",
    fill: "#581800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.525 61.1572C130.167 61.3153 138.518 68.1913 138.518 77.8334C138.518 87.4756 130.167 96.0639 120.525 96.0639C110.883 96.0639 102.927 88.2396 103.085 78.6238C103.217 68.8762 111.094 61.0255 120.525 61.1836V61.1572Z",
    fill: "#5A1900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.551 61.1831C130.194 61.3412 138.571 68.1908 138.571 77.8329C138.571 87.4751 130.194 96.0898 120.551 96.0898C110.909 96.0898 102.953 88.2654 103.111 78.6496C103.269 68.9021 111.12 61.0514 120.551 61.2095V61.1831Z",
    fill: "#5C1900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.578 61.2099C130.22 61.3679 138.598 68.2175 138.598 77.8333C138.598 87.4492 130.22 96.0902 120.578 96.0902C110.936 96.0902 102.98 88.2659 103.138 78.65C103.296 68.9025 111.173 61.0518 120.578 61.2099Z",
    fill: "#5E1A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.578 61.2353C130.22 61.3933 138.598 68.2166 138.598 77.8587C138.598 87.5009 130.22 96.1156 120.578 96.1156C110.936 96.1156 102.98 88.3176 103.138 78.6754C103.296 68.9279 111.173 61.0772 120.578 61.2353Z",
    fill: "#5F1A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.604 61.2626C130.22 61.4207 138.624 68.2176 138.624 77.8598C138.624 87.5019 130.22 96.143 120.604 96.143C110.988 96.143 103.006 88.3449 103.164 78.7028C103.322 68.9553 111.199 61.1045 120.604 61.2626Z",
    fill: "#611A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63 61.3143C130.246 61.4988 138.676 68.2693 138.676 77.8851C138.676 87.5009 130.272 96.1683 120.63 96.1683C110.988 96.1683 103.032 88.3703 103.19 78.7282C103.348 68.9806 111.225 61.1299 120.63 61.288V61.3143Z",
    fill: "#631B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63 61.3407C130.246 61.5251 138.676 68.2694 138.676 77.9115C138.676 87.5537 130.246 96.2211 120.63 96.2211C111.014 96.2211 103.032 88.423 103.19 78.7809C103.348 69.0334 111.225 61.1827 120.63 61.3407Z",
    fill: "#641B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.656 61.3671C130.272 61.5515 138.702 68.2957 138.702 77.9115C138.702 87.5273 130.272 96.2211 120.656 96.2211C111.041 96.2211 103.058 88.423 103.216 78.7809C103.374 69.0334 111.251 61.1827 120.656 61.3407V61.3671Z",
    fill: "#661C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.683 61.394C130.299 61.5785 138.729 68.2963 138.729 77.9121C138.729 87.528 130.299 96.2481 120.683 96.2481C111.067 96.2481 103.085 88.45 103.269 78.8342C103.427 69.0867 111.304 61.236 120.683 61.4204V61.394Z",
    fill: "#681C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.709 61.4209C130.325 61.6053 138.782 68.2968 138.782 77.939C138.782 87.5812 130.325 96.2749 120.709 96.2749C111.093 96.2749 103.111 88.4769 103.295 78.8611C103.453 69.1135 111.33 61.2628 120.709 61.4472V61.4209Z",
    fill: "#691D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.709 61.4468C130.325 61.6312 138.782 68.3227 138.782 77.9385C138.782 87.5544 130.325 96.3008 120.709 96.3008C111.093 96.3008 103.111 88.5028 103.295 78.887C103.453 69.1394 111.33 61.2887 120.709 61.4731V61.4468Z",
    fill: "#6B1D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.736 61.4729C130.351 61.6573 138.808 68.3225 138.808 77.9383C138.808 87.5541 130.351 96.3006 120.736 96.3006C111.12 96.3006 103.137 88.5025 103.322 78.8867C103.506 69.1392 111.357 61.2885 120.736 61.4729Z",
    fill: "#6D1E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.762 61.4998C130.378 61.6842 138.861 68.323 138.861 77.9652C138.861 87.6073 130.378 96.3274 120.762 96.3274C111.146 96.3274 103.164 88.5294 103.348 78.9136C103.533 69.1661 111.383 61.3154 120.762 61.4998Z",
    fill: "#6F1E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.762 61.5256C130.378 61.7364 138.861 68.3489 138.861 77.9647C138.861 87.5805 130.378 96.3533 120.762 96.3533C111.146 96.3533 103.164 88.5553 103.348 78.9395C103.533 69.1919 111.41 61.3412 120.762 61.5256Z",
    fill: "#701F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.788 61.552C130.404 61.7627 138.887 68.3489 138.887 77.9647C138.887 87.5805 130.404 96.3533 120.788 96.3533C111.172 96.3533 103.216 88.5553 103.374 78.9395C103.559 69.1919 111.436 61.3412 120.788 61.5256V61.552Z",
    fill: "#721F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.815 61.6052C130.43 61.816 138.913 68.4021 138.913 78.018C138.913 87.6338 130.404 96.4329 120.815 96.4329C111.225 96.4329 103.243 88.6349 103.401 79.0191C103.585 69.2715 111.462 61.4208 120.815 61.6052Z",
    fill: "#742000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.841 61.6306C130.457 61.8414 138.966 68.4012 138.966 78.017C138.966 87.6328 130.457 96.4319 120.841 96.4319C111.225 96.4319 103.269 88.6339 103.427 79.0181C103.612 69.2706 111.489 61.4199 120.841 61.6306Z",
    fill: "#752000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.841 61.6577C130.457 61.8685 138.966 68.4019 138.966 78.0178C138.966 87.6336 130.457 96.459 120.841 96.459C111.225 96.459 103.269 88.661 103.454 79.0715C103.638 69.324 111.515 61.4733 120.841 61.6841V61.6577Z",
    fill: "#772000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.867 61.6833C130.483 61.8941 138.993 68.4276 138.993 78.017C138.993 87.6065 130.457 96.4583 120.867 96.4583C111.278 96.4583 103.296 88.6603 103.48 79.0708C103.664 69.3233 111.541 61.4726 120.867 61.6833Z",
    fill: "#792100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.894 61.7107C130.483 61.9214 139.045 68.4286 139.045 78.0444C139.045 87.6602 130.51 96.4856 120.894 96.4856C111.278 96.4856 103.322 88.6876 103.506 79.0982C103.691 69.3506 111.568 61.4999 120.894 61.7107Z",
    fill: "#7A2100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.894 61.7361C130.483 61.9468 139.045 68.454 139.045 78.0434C139.045 87.6329 130.51 96.5111 120.894 96.5111C111.278 96.5111 103.322 88.713 103.506 79.1236C103.717 69.3761 111.568 61.5253 120.894 61.7361Z",
    fill: "#7C2200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92 61.7624C130.51 61.9732 139.072 68.454 139.072 78.0434C139.072 87.6329 130.51 96.5111 120.92 96.5111C111.331 96.5111 103.348 88.713 103.533 79.1236C103.743 69.3761 111.594 61.5253 120.92 61.7361V61.7624Z",
    fill: "#7E2200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.947 61.7893C130.536 62.0264 139.098 68.4545 139.098 78.0703C139.098 87.6861 130.536 96.5643 120.947 96.5643C111.357 96.5643 103.375 88.7926 103.559 79.1768C103.77 69.4293 111.621 61.5785 120.947 61.7893Z",
    fill: "#802300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.973 61.8156C130.562 62.0527 139.151 68.4809 139.151 78.0703C139.151 87.6598 130.589 96.5643 120.973 96.5643C111.357 96.5643 103.401 88.7926 103.585 79.1768C103.796 69.4293 111.647 61.5785 120.973 61.7893V61.8156Z",
    fill: "#812300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.973 61.8684C130.562 62.1055 139.151 68.5072 139.151 78.0967C139.151 87.6862 130.562 96.617 120.973 96.617C111.383 96.617 103.401 88.8453 103.585 79.2295C103.796 69.482 111.673 61.6313 120.973 61.842V61.8684Z",
    fill: "#832400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.999 61.894C130.588 62.1311 139.177 68.5329 139.177 78.1224C139.177 87.7118 130.588 96.6427 120.999 96.6427C111.41 96.6427 103.427 88.871 103.638 79.2815C103.849 69.534 111.726 61.6833 120.999 61.9204V61.894Z",
    fill: "#852400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.025 61.9214C130.615 62.1585 139.203 68.5339 139.203 78.1234C139.203 87.7128 130.615 96.67 121.025 96.67C111.436 96.67 103.453 88.8983 103.664 79.3089C103.875 69.5614 111.752 61.7106 121.025 61.9477V61.9214Z",
    fill: "#862500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.025 61.9471C130.615 62.1842 139.23 68.5333 139.23 78.1228C139.23 87.7122 130.615 96.6694 121.025 96.6694C111.436 96.6694 103.453 88.8977 103.664 79.3083C103.875 69.5607 111.752 61.71 121.025 61.9471Z",
    fill: "#882500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.052 61.974C130.641 62.2111 139.256 68.5602 139.256 78.1496C139.256 87.7391 130.641 96.6963 121.052 96.6963C111.462 96.6963 103.48 88.9246 103.691 79.3351C103.901 69.5876 111.778 61.7369 121.052 61.974Z",
    fill: "#8A2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.078 61.9999C130.668 62.237 139.282 68.5597 139.282 78.1491C139.282 87.7386 130.668 96.7221 121.078 96.7221C111.489 96.7221 103.506 88.9505 103.717 79.361C103.928 69.6135 111.805 61.7628 121.078 61.9999Z",
    fill: "#8B2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.104 62.0262C130.694 62.2633 139.335 68.5597 139.335 78.1491C139.335 87.7386 130.694 96.7221 121.104 96.7221C111.515 96.7221 103.533 88.9505 103.743 79.361C103.98 69.6135 111.831 61.7628 121.104 61.9999V62.0262Z",
    fill: "#8D2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.104 62.0526C130.694 62.316 139.335 68.5861 139.335 78.1755C139.335 87.765 130.694 96.7749 121.104 96.7749C111.515 96.7749 103.533 89.0032 103.743 79.4137C103.98 69.6662 111.831 61.8155 121.104 62.0526Z",
    fill: "#8F2700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.131 62.0789C130.72 62.3424 139.361 68.5861 139.361 78.1755C139.361 87.765 130.72 96.7749 121.131 96.7749C111.541 96.7749 103.559 89.0032 103.77 79.4137C104.007 69.6662 111.858 61.8155 121.131 62.0526V62.0789Z",
    fill: "#912700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.157 62.105C130.72 62.3684 139.388 68.6121 139.388 78.1752C139.388 87.7384 130.72 96.8009 121.157 96.8009C111.594 96.8009 103.585 89.0293 103.822 79.4661C104.059 69.7186 111.91 61.8679 121.157 62.1313V62.105Z",
    fill: "#922800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.157 62.1582C130.72 62.4216 139.414 68.639 139.414 78.2285C139.414 87.8179 130.747 96.8541 121.157 96.8541C111.568 96.8541 103.585 89.0825 103.822 79.5193C104.059 69.7718 111.936 61.9211 121.157 62.1846V62.1582Z",
    fill: "#942800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.183 62.1851C130.747 62.4485 139.44 68.6395 139.44 78.229C139.44 87.8184 130.773 96.881 121.183 96.881C111.594 96.881 103.612 89.1093 103.849 79.5462C104.086 69.7987 111.963 61.9479 121.183 62.2114V62.1851Z",
    fill: "#962900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21 62.2105C130.773 62.474 139.467 68.665 139.467 78.2281C139.467 87.7912 130.773 96.8801 121.21 96.8801C111.647 96.8801 103.638 89.1085 103.875 79.5453C104.112 69.7978 111.989 61.9471 121.21 62.2105Z",
    fill: "#972900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.236 62.2364C130.799 62.4999 139.493 68.6645 139.493 78.254C139.493 87.8435 130.799 96.906 121.236 96.906C111.673 96.906 103.664 89.1343 103.901 79.5712C104.138 69.8237 112.016 61.973 121.236 62.2364Z",
    fill: "#992A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.236 62.2633C130.799 62.5267 139.519 68.6914 139.519 78.2545C139.519 87.8176 130.826 96.9329 121.236 96.9329C111.647 96.9329 103.664 89.1612 103.901 79.5981C104.138 69.8505 112.016 61.9998 121.236 62.2633Z",
    fill: "#9B2A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.263 62.2896C130.826 62.5531 139.546 68.6914 139.546 78.2545C139.546 87.8176 130.826 96.9329 121.263 96.9329C111.699 96.9329 103.691 89.1612 103.928 79.5981C104.165 69.8505 112.042 61.9998 121.263 62.2633V62.2896Z",
    fill: "#9C2B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.289 62.316C130.852 62.6058 139.572 68.6914 139.572 78.2809C139.572 87.8703 130.852 96.9856 121.289 96.9856C111.726 96.9856 103.717 89.2139 103.954 79.6508C104.218 69.9033 112.068 62.0526 121.289 62.316Z",
    fill: "#9E2B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.289 62.3424C130.852 62.6322 139.598 68.7178 139.598 78.2809C139.598 87.844 130.878 96.9856 121.289 96.9856C111.699 96.9856 103.717 89.2139 103.954 79.6508C104.218 69.9033 112.068 62.0526 121.289 62.316V62.3424Z",
    fill: "#A02C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.315 62.3691C130.878 62.6589 139.625 68.7182 139.625 78.2813C139.625 87.8444 130.878 97.0124 121.315 97.0124C111.752 97.0124 103.743 89.267 104.007 79.7039C104.27 69.9564 112.121 62.1057 121.315 62.3955V62.3691Z",
    fill: "#A22C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.342 62.3945C130.905 62.6843 139.651 68.7172 139.651 78.2803C139.651 87.8434 130.905 97.0114 121.342 97.0114C111.779 97.0114 103.77 89.2661 104.033 79.7029C104.297 69.9554 112.147 62.1047 121.342 62.3945Z",
    fill: "#A32D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.368 62.4473C130.931 62.7371 139.678 68.77 139.678 78.3331C139.678 87.8962 130.931 97.0905 121.368 97.0905C111.805 97.0905 103.796 89.3452 104.06 79.7821C104.323 70.0345 112.174 62.1838 121.368 62.4736V62.4473Z",
    fill: "#A52D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.368 62.4746C130.931 62.7644 139.704 68.771 139.704 78.3341C139.704 87.8972 130.931 97.0915 121.368 97.0915C111.805 97.0915 103.796 89.3462 104.06 79.783C104.323 70.0355 112.2 62.1848 121.368 62.4746Z",
    fill: "#A72D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.394 62.5009C130.957 62.7907 139.73 68.7973 139.73 78.3341C139.73 87.8708 130.957 97.0915 121.394 97.0915C111.831 97.0915 103.822 89.3462 104.086 79.783C104.349 70.0355 112.226 62.1848 121.394 62.4746V62.5009Z",
    fill: "#A82E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.421 62.5273C130.984 62.8171 139.757 68.7973 139.757 78.3605C139.757 87.9236 130.984 97.1442 121.421 97.1442C111.858 97.1442 103.849 89.3989 104.112 79.8358C104.376 70.0882 112.253 62.2375 121.421 62.5273Z",
    fill: "#AA2E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.421 62.5537C130.957 62.8434 139.757 68.7973 139.757 78.3605C139.757 87.9236 130.957 97.1442 121.421 97.1442C111.884 97.1442 103.849 89.3989 104.112 79.8358C104.376 70.0882 112.253 62.2375 121.421 62.5273V62.5537Z",
    fill: "#AC2F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.447 62.579C130.984 62.8952 139.809 68.8227 139.809 78.3595C139.809 87.8963 131.01 97.1696 121.447 97.1696C111.884 97.1696 103.875 89.4243 104.139 79.8611C104.402 70.1136 112.279 62.2629 121.447 62.5527V62.579Z",
    fill: "#AD2F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.473 62.6055C131.01 62.9216 139.836 68.8228 139.836 78.3859C139.836 87.949 131.036 97.196 121.473 97.196C111.91 97.196 103.901 89.4507 104.191 79.9139C104.481 70.1664 112.332 62.3157 121.473 62.6318V62.6055Z",
    fill: "#AF3000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5 62.6328C131.036 62.9489 139.862 68.8501 139.862 78.3869C139.862 87.9237 131.036 97.2234 121.5 97.2234C111.963 97.2234 103.928 89.478 104.218 79.9413C104.507 70.1937 112.358 62.343 121.5 62.6592V62.6328Z",
    fill: "#B13000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5 62.6586C131.036 62.9748 139.888 68.8496 139.888 78.3864C139.888 87.9232 131.063 97.2228 121.5 97.2228C111.937 97.2228 103.928 89.4775 104.218 79.9407C104.507 70.1932 112.358 62.3425 121.5 62.6586Z",
    fill: "#B33100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.526 62.7114C131.063 63.0275 139.915 68.876 139.915 78.4391C139.915 88.0023 131.089 97.2756 121.526 97.2756C111.963 97.2756 103.954 89.5302 104.244 79.9935C104.534 70.2459 112.384 62.3952 121.526 62.7114Z",
    fill: "#B43100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.553 62.7373C131.089 63.0534 139.941 68.9019 139.941 78.4387C139.941 87.9754 131.089 97.3014 121.553 97.3014C112.016 97.3014 103.981 89.5561 104.271 80.0194C104.56 70.2718 112.411 62.4211 121.553 62.7373Z",
    fill: "#B63200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.553 62.7636C131.089 63.0797 139.941 68.9019 139.941 78.4387C139.941 87.9754 131.089 97.3014 121.553 97.3014C112.016 97.3014 103.981 89.5561 104.271 80.0194C104.56 70.2718 112.411 62.4211 121.553 62.7373V62.7636Z",
    fill: "#B83200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.579 62.79C131.116 63.1062 139.994 68.902 139.994 78.4651C139.994 88.0282 131.116 97.3542 121.579 97.3542C112.042 97.3542 104.007 89.6089 104.297 80.0721C104.587 70.2982 112.464 62.4739 121.579 62.79Z",
    fill: "#B93300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.02 78.4651C140.02 88.0019 131.142 97.3542 121.605 97.3542C112.069 97.3542 104.033 89.6089 104.323 80.0721C104.613 70.2982 112.49 62.4739 121.605 62.79C131.142 63.1325 140.02 68.902 140.02 78.4388V78.4651Z",
    fill: "#BB3300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M121.605 62.8423C131.142 63.1584 140.02 68.9542 140.02 78.5173C140.02 88.0805 131.169 97.4065 121.605 97.4065C112.042 97.4065 104.034 89.6611 104.323 80.1244C104.613 70.3768 112.49 62.5525 121.605 62.8423Z",
    fill: "#BC3502"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M121.632 62.8686C131.168 63.1847 140.02 69.0069 140.02 78.5437C140.02 88.0805 131.168 97.4065 121.632 97.4065C112.095 97.4065 104.086 89.6611 104.35 80.1244C104.639 70.3768 112.49 62.5525 121.632 62.8423V62.8686Z",
    fill: "#BC3705"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M121.632 62.8696C131.168 63.1858 140.02 69.0343 140.02 78.571C140.02 88.1078 131.168 97.4338 121.632 97.4338C112.095 97.4338 104.086 89.6885 104.35 80.1517C104.639 70.4042 112.49 62.5798 121.632 62.8696Z",
    fill: "#BD3907"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M121.657 62.896C131.194 63.2121 140.02 69.0606 140.02 78.5974C140.02 88.1342 131.194 97.4338 121.657 97.4338C112.121 97.4338 104.112 89.6885 104.375 80.1517C104.665 70.4042 112.516 62.5798 121.657 62.8696V62.896Z",
    fill: "#BD3A09"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M121.684 62.9214C131.22 63.2375 140.046 69.1124 140.046 78.6491C140.046 88.1859 131.22 97.4592 121.684 97.4592C112.147 97.4592 104.138 89.7139 104.402 80.1771C104.691 70.4296 112.542 62.6052 121.684 62.895V62.9214Z",
    fill: "#BE3C0C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M121.684 62.9487C131.22 63.2648 140.046 69.1397 140.046 78.6765C140.046 88.2132 131.247 97.4865 121.684 97.4865C112.121 97.4865 104.138 89.7412 104.402 80.2044C104.691 70.4569 112.542 62.6326 121.684 62.9223V62.9487Z",
    fill: "#BF3E0E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M121.71 62.9741C131.247 63.2902 140.046 69.1914 140.046 78.7282C140.046 88.265 131.247 97.512 121.71 97.512C112.173 97.512 104.165 89.7666 104.428 80.2299C104.718 70.4823 112.568 62.6579 121.71 62.9477V62.9741Z",
    fill: "#BF4010"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M121.71 63.0014C131.247 63.3176 140.046 69.2188 140.046 78.7555C140.046 88.2923 131.247 97.5393 121.71 97.5393C112.173 97.5393 104.165 89.794 104.428 80.2572C104.691 70.5097 112.542 62.6853 121.71 62.9751V63.0014Z",
    fill: "#C04213"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M121.736 63.0014C131.273 63.2912 140.046 69.2451 140.046 78.7819C140.046 88.3187 131.273 97.5393 121.736 97.5393C112.2 97.5393 104.191 89.794 104.454 80.2572C104.718 70.5097 112.568 62.6853 121.736 62.9751V63.0014Z",
    fill: "#C14415"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M121.736 63.0275C131.273 63.3173 140.046 69.2712 140.046 78.8343C140.046 88.3974 131.273 97.5917 121.736 97.5917C112.2 97.5917 104.191 89.8464 104.454 80.3096C104.718 70.5621 112.568 62.764 121.736 63.0275Z",
    fill: "#C14617"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M121.763 63.0538C131.3 63.3436 140.072 69.3238 140.072 78.8606C140.072 88.3974 131.3 97.5917 121.763 97.5917C112.226 97.5917 104.217 89.8464 104.481 80.3096C104.744 70.5621 112.595 62.764 121.763 63.0275V63.0538Z",
    fill: "#C24719"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M121.789 63.0802C131.326 63.37 140.073 69.3766 140.073 78.9134C140.073 88.4501 131.326 97.6444 121.789 97.6444C112.253 97.6444 104.27 89.8991 104.507 80.3623C104.771 70.6148 112.621 62.8168 121.789 63.0802Z",
    fill: "#C2491C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M121.789 63.1066C131.326 63.3964 140.073 69.4029 140.073 78.9397C140.073 88.4765 131.326 97.6444 121.789 97.6444C112.253 97.6444 104.27 89.8991 104.507 80.3623C104.771 70.6148 112.621 62.8168 121.789 63.0802V63.1066Z",
    fill: "#C34B1E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M121.816 63.1324C131.353 63.4222 140.073 69.4551 140.073 78.9919C140.073 88.5287 131.353 97.6703 121.816 97.6703C112.279 97.6703 104.297 89.9249 104.534 80.3882C104.797 70.667 112.648 62.8426 121.816 63.1061V63.1324Z",
    fill: "#C44D20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M121.816 63.1593C131.353 63.4491 140.073 69.482 140.073 79.0188C140.073 88.5556 131.353 97.6971 121.816 97.6971C112.279 97.6971 104.297 89.9518 104.534 80.415C104.797 70.6939 112.622 62.8695 121.816 63.1329V63.1593Z",
    fill: "#C44F23"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M121.842 63.1593C131.379 63.4491 140.099 69.5083 140.099 79.0451C140.099 88.5819 131.379 97.6971 121.842 97.6971C112.305 97.6971 104.323 89.9518 104.56 80.415C104.824 70.6939 112.648 62.8695 121.842 63.1329V63.1593Z",
    fill: "#C55125"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M121.842 63.1852C131.379 63.4749 140.073 69.5342 140.073 79.071C140.073 88.6078 131.379 97.723 121.842 97.723C112.305 97.723 104.323 89.9777 104.56 80.4409C104.824 70.7197 112.648 62.8954 121.842 63.1588V63.1852Z",
    fill: "#C65327"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M121.869 63.212C131.405 63.4755 140.099 69.5874 140.099 79.1242C140.099 88.661 131.405 97.7499 121.869 97.7499C112.332 97.7499 104.349 90.0045 104.586 80.4678C104.824 70.7466 112.674 62.9222 121.869 63.1857V63.212Z",
    fill: "#C6542A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M121.869 63.2387C131.405 63.5021 140.073 69.6141 140.073 79.1772C140.073 88.7403 131.405 97.8029 121.869 97.8029C112.332 97.8029 104.349 90.0576 104.586 80.5208C104.824 70.7996 112.674 63.0016 121.869 63.2387Z",
    fill: "#C7562C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M121.895 63.265C131.432 63.5285 140.099 69.6668 140.099 79.2036C140.099 88.7403 131.432 97.8029 121.895 97.8029C112.358 97.8029 104.376 90.0576 104.613 80.5208C104.85 70.7996 112.701 63.0016 121.895 63.2387V63.265Z",
    fill: "#C7582E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M121.921 63.2909C131.458 63.5543 140.125 69.719 140.125 79.2558C140.125 88.7925 131.458 97.8288 121.921 97.8288C112.385 97.8288 104.402 90.0834 104.639 80.5466C104.876 70.8255 112.727 63.0274 121.921 63.2645V63.2909Z",
    fill: "#C85A31"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M121.921 63.2909C131.458 63.5543 140.099 69.719 140.099 79.2558C140.099 88.7925 131.458 97.8288 121.921 97.8288C112.385 97.8288 104.429 90.0834 104.639 80.5466C104.876 70.8255 112.701 63.0274 121.921 63.2645V63.2909Z",
    fill: "#C95C33"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M121.947 63.3178C131.484 63.5812 140.125 69.7722 140.125 79.309C140.125 88.8457 131.484 97.8556 121.947 97.8556C112.41 97.8556 104.454 90.1103 104.665 80.5735C104.902 70.8523 112.726 63.0543 121.947 63.2914V63.3178Z",
    fill: "#C95E35"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M121.947 63.3436C131.484 63.6071 140.099 69.7981 140.099 79.3348C140.099 88.8716 131.484 97.8815 121.947 97.8815C112.41 97.8815 104.454 90.1362 104.665 80.5994C104.902 70.8782 112.726 63.0802 121.947 63.3173V63.3436Z",
    fill: "#CA6038"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M121.973 63.3705C131.51 63.6339 140.125 69.8513 140.125 79.3881C140.125 88.9248 131.51 97.9084 121.973 97.9084C112.437 97.9084 104.481 90.163 104.691 80.6263C104.928 70.9051 112.753 63.107 121.973 63.3441V63.3705Z",
    fill: "#CA613A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M121.973 63.3969C131.51 63.6603 140.125 69.8776 140.125 79.4408C140.125 89.0039 131.51 97.9611 121.973 97.9611C112.437 97.9611 104.481 90.2157 104.691 80.679C104.928 70.9578 112.753 63.1598 121.973 63.3969Z",
    fill: "#CB633C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M122 63.4232C131.537 63.6603 140.125 69.9303 140.125 79.4671C140.125 89.0039 131.537 97.9611 122 97.9611C112.463 97.9611 104.507 90.2157 104.718 80.679C104.955 70.9841 112.779 63.1597 122 63.3969V63.4232Z",
    fill: "#CC653F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M122 63.4227C131.537 63.6598 140.125 69.9562 140.125 79.493C140.125 89.0298 131.537 97.987 122 97.987C112.463 97.987 104.507 90.2416 104.718 80.7048C104.928 71.01 112.779 63.1856 122 63.4227Z",
    fill: "#CC6741"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M122.026 63.449C131.563 63.6861 140.151 69.9825 140.151 79.5192C140.151 89.056 131.589 97.9868 122.026 97.9868C112.463 97.9868 104.533 90.2415 104.744 80.7047C104.955 71.0099 112.779 63.2119 122.026 63.4226V63.449Z",
    fill: "#CD6943"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M122.053 63.4749C131.589 63.712 140.151 70.0347 140.151 79.5715C140.151 89.1082 131.589 98.0127 122.053 98.0127C112.516 98.0127 104.56 90.2674 104.77 80.7306C104.981 71.0358 112.806 63.2378 122.053 63.4485V63.4749Z",
    fill: "#CE6B46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M122.053 63.5017C131.589 63.7388 140.151 70.0615 140.151 79.5983C140.151 89.1351 131.589 98.0396 122.053 98.0396C112.516 98.0396 104.56 90.2942 104.77 80.7575C104.981 71.0626 112.806 63.2646 122.053 63.4754V63.5017Z",
    fill: "#CE6C48"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M122.079 63.5276C131.616 63.7647 140.152 70.1138 140.152 79.6505C140.152 89.1873 131.616 98.0654 122.079 98.0654C112.543 98.0654 104.613 90.3201 104.797 80.7833C105.008 71.0885 112.832 63.2905 122.079 63.5012V63.5276Z",
    fill: "#CF6E4A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M122.079 63.5544C131.616 63.7916 140.152 70.1406 140.152 79.6774C140.152 89.2142 131.616 98.0923 122.079 98.0923C112.543 98.0923 104.613 90.347 104.797 80.8102C105.008 71.1154 112.832 63.3173 122.079 63.5281V63.5544Z",
    fill: "#CF704C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M122.106 63.5544C131.643 63.7916 140.178 70.167 140.178 79.7037C140.178 89.2405 131.669 98.0923 122.106 98.0923C112.543 98.0923 104.639 90.347 104.824 80.8102C105.034 71.1154 112.859 63.3173 122.106 63.5281V63.5544Z",
    fill: "#D0724F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M122.106 63.5808C131.643 63.8179 140.152 70.1933 140.152 79.7565C140.152 89.3196 131.643 98.145 122.106 98.145C112.569 98.145 104.639 90.3997 104.824 80.8629C105.034 71.1681 112.859 63.3701 122.106 63.5808Z",
    fill: "#D17451"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M122.132 63.6072C131.669 63.8179 140.178 70.246 140.178 79.7828C140.178 89.3196 131.669 98.145 122.132 98.145C112.595 98.145 104.666 90.3997 104.85 80.8629C105.061 71.1681 112.859 63.3701 122.132 63.5808V63.6072Z",
    fill: "#D17653"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M122.132 63.6336C131.669 63.8443 140.152 70.2988 140.152 79.8355C140.152 89.3723 131.669 98.1978 122.132 98.1978C112.595 98.1978 104.666 90.4524 104.85 80.9157C105.061 71.2208 112.859 63.4228 122.132 63.6336Z",
    fill: "#D27856"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M122.159 63.659C131.695 63.8697 140.178 70.3242 140.178 79.8609C140.178 89.3977 131.695 98.1968 122.159 98.1968C112.622 98.1968 104.692 90.4515 104.876 80.9147C105.061 71.2199 112.885 63.4482 122.159 63.6326V63.659Z",
    fill: "#D27958"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M122.185 63.6863C131.722 63.8971 140.205 70.3778 140.205 79.9146C140.205 89.4514 131.748 98.2242 122.185 98.2242C112.622 98.2242 104.718 90.4788 104.903 80.9421C105.087 71.2472 112.912 63.4755 122.185 63.66V63.6863Z",
    fill: "#D37B5A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M122.185 63.6863C131.722 63.8971 140.178 70.3778 140.178 79.9146C140.178 89.4514 131.722 98.2242 122.185 98.2242C112.648 98.2242 104.718 90.4788 104.903 80.942C105.087 71.2735 112.912 63.4755 122.185 63.6599V63.6863Z",
    fill: "#D47D5D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M122.211 63.7117C131.748 63.9224 140.205 70.4296 140.205 79.9663C140.205 89.5031 131.748 98.2495 122.211 98.2495C112.675 98.2495 104.745 90.5042 104.929 80.9674C105.114 71.2989 112.938 63.5009 122.211 63.6853V63.7117Z",
    fill: "#D47F5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M122.211 63.739C131.748 63.9498 140.178 70.4569 140.178 79.9937C140.178 89.5305 131.748 98.2769 122.211 98.2769C112.674 98.2769 104.771 90.5316 104.929 80.9948C105.113 71.3263 112.911 63.5283 122.211 63.7127V63.739Z",
    fill: "#D58161"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M122.237 63.7644C131.774 63.9752 140.204 70.5087 140.204 80.0454C140.204 89.5822 131.774 98.3023 122.237 98.3023C112.701 98.3023 104.797 90.5569 104.955 81.0202C105.14 71.3517 112.938 63.5537 122.237 63.7381V63.7644Z",
    fill: "#D68364"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M122.237 63.7908C131.774 64.0016 140.204 70.5614 140.204 80.0982C140.204 89.6349 131.774 98.355 122.237 98.355C112.701 98.355 104.797 90.6097 104.955 81.0729C105.14 71.4044 112.938 63.6064 122.237 63.7908Z",
    fill: "#D68566"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M122.264 63.8172C131.8 64.0016 140.204 70.5877 140.204 80.1245C140.204 89.6613 131.8 98.355 122.264 98.355C112.727 98.355 104.824 90.6097 104.982 81.0729C105.166 71.4044 112.964 63.6064 122.264 63.7908V63.8172Z",
    fill: "#D78668"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M122.29 63.8445C131.827 64.0289 140.231 70.6414 140.231 80.1782C140.231 89.715 131.827 98.3824 122.29 98.3824C112.753 98.3824 104.85 90.6371 105.008 81.1003C105.192 71.4318 112.99 63.6337 122.29 63.8181V63.8445Z",
    fill: "#D7886B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M122.29 63.8437C131.827 64.0281 140.204 70.6406 140.204 80.1774C140.204 89.7141 131.827 98.3815 122.29 98.3815C112.753 98.3815 104.85 90.6362 105.008 81.0994C105.166 71.4309 112.99 63.6592 122.29 63.8173V63.8437Z",
    fill: "#D88A6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M122.316 63.8705C131.853 64.0549 140.231 70.6938 140.231 80.2306C140.231 89.7673 131.853 98.4084 122.316 98.4084C112.78 98.4084 104.876 90.663 105.034 81.1263C105.192 71.4578 113.017 63.6861 122.316 63.8442V63.8705Z",
    fill: "#D98C6F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M122.316 63.8964C131.853 64.0808 140.231 70.7196 140.231 80.2564C140.231 89.7932 131.853 98.4342 122.316 98.4342C112.78 98.4342 104.876 90.6889 105.034 81.1521C105.192 71.4836 112.99 63.712 122.316 63.87V63.8964Z",
    fill: "#D98E72"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M122.343 63.9233C131.88 64.1077 140.231 70.7729 140.231 80.3096C140.231 89.8464 131.88 98.4611 122.343 98.4611C112.806 98.4611 104.903 90.7158 105.061 81.179C105.219 71.5105 113.017 63.7388 122.343 63.8969V63.9233Z",
    fill: "#DA9074"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M122.343 63.9496C131.88 64.134 140.231 70.7992 140.231 80.3624C140.231 89.9255 131.88 98.5138 122.343 98.5138C112.806 98.5138 104.903 90.7685 105.061 81.2317C105.219 71.5632 113.017 63.7916 122.343 63.9496Z",
    fill: "#DB9276"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M122.369 63.976C131.906 64.1604 140.231 70.8519 140.231 80.3887C140.231 89.9255 131.906 98.5138 122.369 98.5138C112.832 98.5138 104.955 90.7685 105.087 81.2317C105.245 71.5632 113.043 63.7916 122.369 63.9496V63.976Z",
    fill: "#DB9379"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M122.369 63.9755C131.906 64.1336 140.231 70.8778 140.231 80.4146C140.231 89.9514 131.906 98.5397 122.369 98.5397C112.832 98.5397 104.955 90.7944 105.087 81.2576C105.245 71.6155 113.043 63.8174 122.369 63.9755Z",
    fill: "#DC957B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M122.396 64.0018C131.932 64.1599 140.257 70.9042 140.257 80.4409C140.257 89.9777 131.932 98.5397 122.396 98.5397C112.859 98.5397 104.982 90.7944 105.113 81.2576C105.272 71.6155 113.07 63.8174 122.396 63.9755V64.0018Z",
    fill: "#DC977D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.422 64.0287C131.959 64.1868 140.257 70.9574 140.257 80.4941C140.257 90.0309 131.959 98.5666 122.422 98.5666C112.885 98.5666 105.008 90.8213 105.14 81.2845C105.298 71.6423 113.096 63.8443 122.422 64.0024V64.0287Z",
    fill: "#DD9980"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M122.422 64.0549C131.959 64.2129 140.257 70.9835 140.257 80.5203C140.257 90.0571 131.959 98.5927 122.422 98.5927C112.885 98.5927 105.008 90.8474 105.14 81.3106C105.298 71.6685 113.07 63.8968 122.422 64.0285V64.0549Z",
    fill: "#DE9B82"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M122.448 64.0807C131.985 64.2388 140.257 71.0357 140.257 80.5725C140.257 90.1093 131.985 98.6186 122.448 98.6186C112.912 98.6186 105.034 90.8733 105.166 81.3365C105.298 71.6943 113.096 63.9227 122.448 64.0544V64.0807Z",
    fill: "#DE9D84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M122.448 64.1076C131.985 64.2657 140.257 71.0626 140.257 80.5994C140.257 90.1361 131.985 98.6455 122.448 98.6455C112.912 98.6455 105.034 90.9001 105.166 81.3634C105.298 71.7212 113.096 63.9495 122.448 64.0812V64.1076Z",
    fill: "#DF9F86"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M122.475 64.1076C132.011 64.2657 140.284 71.0889 140.284 80.6257C140.284 90.1625 132.011 98.6455 122.475 98.6455C112.938 98.6455 105.061 90.9001 105.193 81.3634C105.324 71.7212 113.122 63.9495 122.475 64.0812V64.1076Z",
    fill: "#DFA089"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M122.475 64.134C132.011 64.292 140.257 71.1153 140.257 80.6784C140.257 90.2415 132.011 98.6982 122.475 98.6982C112.938 98.6982 105.061 90.9528 105.193 81.4161C105.324 71.7739 113.122 64.0023 122.475 64.134Z",
    fill: "#E0A28B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M122.5 64.1603C132.037 64.3184 140.283 71.168 140.283 80.7048C140.283 90.2415 132.037 98.6982 122.5 98.6982C112.964 98.6982 105.086 90.9528 105.218 81.4161C105.35 71.7739 113.148 64.0023 122.5 64.134V64.1603Z",
    fill: "#E1A48D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M122.5 64.1867C132.037 64.3184 140.283 71.2207 140.283 80.7575C140.283 90.2943 132.064 98.7509 122.5 98.7509C112.937 98.7509 105.113 91.0056 105.218 81.4688C105.35 71.8267 113.148 64.055 122.5 64.1867Z",
    fill: "#E1A690"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M122.527 64.2131C132.064 64.3448 140.283 71.2471 140.283 80.7839C140.283 90.3206 132.064 98.7509 122.527 98.7509C112.99 98.7509 105.139 91.0056 105.245 81.4688C105.376 71.8267 113.148 64.055 122.527 64.1867V64.2131Z",
    fill: "#E2A892"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M122.553 64.2389C132.09 64.3707 140.309 71.2993 140.309 80.8361C140.309 90.3728 132.09 98.7768 122.553 98.7768C113.016 98.7768 105.166 91.0315 105.271 81.4947C105.403 71.8525 113.174 64.0809 122.553 64.2126V64.2389Z",
    fill: "#E3AA94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M122.553 64.2398C132.09 64.3715 140.283 71.3002 140.283 80.8369C140.283 90.3737 132.09 98.7777 122.553 98.7777C113.016 98.7777 105.166 91.0323 105.271 81.4956C105.403 71.8534 113.174 64.1081 122.553 64.2135V64.2398Z",
    fill: "#E3AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.58 64.2652C132.116 64.3969 140.309 71.3519 140.309 80.8887C140.309 90.4255 132.116 98.8031 122.58 98.8031C113.043 98.8031 105.192 91.0577 105.297 81.521C105.429 71.9051 113.201 64.1335 122.58 64.2389V64.2652Z",
    fill: "#E4AD99"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M122.58 64.2925C132.116 64.4243 140.309 71.3793 140.309 80.916C140.309 90.4528 132.143 98.8304 122.58 98.8304C113.016 98.8304 105.192 91.0851 105.297 81.5483C105.403 71.9325 113.201 64.1608 122.58 64.2662V64.2925Z",
    fill: "#E4AF9B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M122.606 64.3179C132.143 64.4497 140.31 71.431 140.31 80.9678C140.31 90.5045 132.143 98.8558 122.606 98.8558C113.069 98.8558 105.218 91.1105 105.324 81.5737C105.429 71.9579 113.227 64.1862 122.606 64.2916V64.3179Z",
    fill: "#E5B19E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M122.606 64.3443C132.143 64.476 140.31 71.4837 140.31 81.0205C140.31 90.5573 132.143 98.9085 122.606 98.9085C113.069 98.9085 105.218 91.1632 105.324 81.6264C105.429 72.0106 113.227 64.2389 122.606 64.3443Z",
    fill: "#E6B3A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M122.632 64.3707C132.169 64.5024 140.31 71.5101 140.31 81.0468C140.31 90.5836 132.169 98.9085 122.632 98.9085C113.095 98.9085 105.245 91.1632 105.35 81.6264C105.456 72.0106 113.227 64.2389 122.632 64.3443V64.3707Z",
    fill: "#E6B5A2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M122.659 64.398C132.195 64.5034 140.336 71.5638 140.336 81.1005C140.336 90.6373 132.195 98.9359 122.659 98.9359C113.122 98.9359 105.271 91.1906 105.377 81.6538C105.482 72.038 113.254 64.2663 122.659 64.3717V64.398Z",
    fill: "#E7B7A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M122.659 64.398C132.196 64.5034 140.336 71.5638 140.336 81.1005C140.336 90.6373 132.222 98.9359 122.659 98.9359C113.096 98.9359 105.298 91.1906 105.377 81.6538C105.482 72.038 113.254 64.2663 122.659 64.3717V64.398Z",
    fill: "#E8B9A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M122.685 64.4234C132.222 64.5288 140.336 71.6155 140.336 81.1523C140.336 90.689 132.222 98.9613 122.685 98.9613C113.149 98.9613 105.324 91.2159 105.403 81.6792C105.509 72.0633 113.28 64.2917 122.685 64.3971V64.4234Z",
    fill: "#E8BAA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M122.685 64.4507C132.222 64.5561 140.336 71.6428 140.336 81.1796C140.336 90.7164 132.222 98.9886 122.685 98.9886C113.149 98.9886 105.324 91.2433 105.403 81.7065C105.509 72.0907 113.28 64.319 122.685 64.4244V64.4507Z",
    fill: "#E9BCAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M122.712 64.4757C132.248 64.5811 140.336 71.6941 140.336 81.2309C140.336 90.7677 132.248 99.0135 122.712 99.0135C113.175 99.0135 105.351 91.2682 105.43 81.7314C105.535 72.1156 113.307 64.3703 122.712 64.4493V64.4757Z",
    fill: "#E9BEAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M122.712 64.5026C132.248 64.6079 140.336 71.721 140.336 81.2841C140.336 90.8472 132.248 99.0668 122.712 99.0668C113.175 99.0668 105.351 91.3214 105.43 81.7847C105.509 72.1688 113.307 64.4235 122.712 64.5026Z",
    fill: "#EAC0B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.738 64.5289C132.275 64.6343 140.363 71.7737 140.363 81.3104C140.363 90.8472 132.301 99.0668 122.738 99.0668C113.175 99.0668 105.377 91.3214 105.456 81.7847C105.535 72.1688 113.307 64.4235 122.738 64.5026V64.5289Z",
    fill: "#EBC2B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M122.738 64.5294C132.275 64.6348 140.336 71.8005 140.336 81.3373C140.336 90.8741 132.275 99.0936 122.738 99.0936C113.201 99.0936 105.377 91.3483 105.456 81.8115C105.535 72.1957 113.307 64.4504 122.738 64.5294Z",
    fill: "#EBC4B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M122.764 64.5557C132.301 64.6611 140.363 71.8269 140.363 81.3637C140.363 90.9004 132.301 99.0936 122.764 99.0936C113.228 99.0936 105.403 91.3483 105.482 81.8115C105.561 72.222 113.333 64.4504 122.764 64.5294V64.5557Z",
    fill: "#ECC6B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M122.791 64.5816C132.328 64.6607 140.363 71.8791 140.363 81.4159C140.363 90.9527 132.328 99.1195 122.791 99.1195C113.254 99.1195 105.43 91.3742 105.509 81.8374C105.588 72.2479 113.359 64.4763 122.791 64.5553V64.5816Z",
    fill: "#ECC7B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M122.791 64.6085C132.328 64.6875 140.363 71.906 140.363 81.4427C140.363 90.9795 132.328 99.1464 122.791 99.1464C113.254 99.1464 105.43 91.401 105.509 81.8642C105.588 72.2748 113.359 64.5031 122.791 64.5821V64.6085Z",
    fill: "#EDC9BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M122.817 64.6344C132.354 64.7134 140.389 71.9582 140.389 81.4949C140.389 91.0317 132.354 99.1722 122.817 99.1722C113.28 99.1722 105.482 91.4269 105.535 81.8901C105.614 72.3007 113.385 64.529 122.817 64.608V64.6344Z",
    fill: "#EECBBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M122.817 64.6612C132.354 64.7402 140.362 71.985 140.362 81.5218C140.362 91.0586 132.354 99.1991 122.817 99.1991C113.28 99.1991 105.482 91.4537 105.535 81.917C105.614 72.3275 113.359 64.5558 122.817 64.6349V64.6612Z",
    fill: "#EECDC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M122.843 64.6609C132.38 64.7399 140.389 72.011 140.389 81.5478C140.389 91.0846 132.38 99.1987 122.843 99.1987C113.306 99.1987 105.508 91.4534 105.561 81.9166C105.64 72.3272 113.385 64.5819 122.843 64.6345V64.6609Z",
    fill: "#EFCFC3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M122.843 64.6873C132.38 64.7663 140.362 72.0638 140.362 81.6006C140.362 91.1373 132.38 99.2515 122.843 99.2515C113.306 99.2515 105.508 91.5062 105.561 81.9694C105.64 72.3799 113.385 64.6346 122.843 64.6873Z",
    fill: "#F0D1C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M122.87 64.7136C132.406 64.7927 140.389 72.0901 140.389 81.6269C140.389 91.1637 132.406 99.2515 122.87 99.2515C113.333 99.2515 105.535 91.5062 105.587 81.9694C105.64 72.3799 113.412 64.6346 122.87 64.6873V64.7136Z",
    fill: "#F0D2C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M122.87 64.74C132.406 64.819 140.389 72.1429 140.389 81.6796C140.389 91.2164 132.406 99.3042 122.87 99.3042C113.333 99.3042 105.535 91.5589 105.587 82.0221C105.64 72.4327 113.412 64.6873 122.87 64.74Z",
    fill: "#F1D4CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.896 64.7664C132.433 64.8454 140.389 72.1692 140.389 81.706C140.389 91.2428 132.433 99.3042 122.896 99.3042C113.359 99.3042 105.561 91.5589 105.614 82.0221C105.666 72.4327 113.438 64.6873 122.896 64.74V64.7664Z",
    fill: "#F1D6CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M122.922 64.7922C132.459 64.8449 140.415 72.2214 140.415 81.7582C140.415 91.295 132.459 99.3301 122.922 99.3301C113.385 99.3301 105.587 91.5848 105.64 82.048C105.693 72.4585 113.465 64.7132 122.922 64.7659V64.7922Z",
    fill: "#F2D8CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M122.922 64.7922C132.459 64.8449 140.389 72.2214 140.389 81.7582C140.389 91.295 132.459 99.3301 122.922 99.3301C113.385 99.3301 105.587 91.5848 105.64 82.048C105.693 72.4585 113.438 64.7132 122.922 64.7659V64.7922Z",
    fill: "#F3DAD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M122.949 64.8191C132.485 64.8718 140.415 72.2746 140.415 81.8114C140.415 91.3482 132.485 99.3569 122.949 99.3569C113.412 99.3569 105.614 91.6116 105.667 82.0748C105.719 72.4854 113.465 64.7401 122.949 64.7927V64.8191Z",
    fill: "#F3DCD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M122.948 64.8455C132.485 64.8982 140.415 72.301 140.415 81.8641C140.415 91.4273 132.485 99.4097 122.948 99.4097C113.412 99.4097 105.64 91.6644 105.666 82.1276C105.719 72.5645 113.464 64.7928 122.948 64.8455Z",
    fill: "#F4DED5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M122.975 64.8716C132.512 64.9243 140.415 72.3535 140.415 81.8903C140.415 91.4271 132.512 99.4095 122.975 99.4095C113.438 99.4095 105.666 91.6642 105.693 82.1274C105.745 72.5643 113.491 64.8189 122.975 64.8453V64.8716Z",
    fill: "#F4DFD8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M122.975 64.898C132.512 64.9507 140.415 72.4063 140.415 81.943C140.415 91.4798 132.512 99.4622 122.975 99.4622C113.438 99.4622 105.666 91.7169 105.693 82.1801C105.745 72.617 113.491 64.8717 122.975 64.898Z",
    fill: "#F5E1DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M123.001 64.9243C132.538 64.977 140.441 72.4326 140.441 81.9694C140.441 91.5061 132.564 99.4622 123.001 99.4622C113.438 99.4622 105.693 91.7169 105.719 82.1801C105.772 72.617 113.517 64.8717 123.001 64.898V64.9243Z",
    fill: "#F6E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M123.001 64.9243C132.538 64.977 140.415 72.4589 140.415 81.9957C140.415 91.5325 132.538 99.4622 123.001 99.4622C113.464 99.4622 105.693 91.7169 105.719 82.1801C105.745 72.617 113.517 64.8717 123.001 64.898V64.9243Z",
    fill: "#F6E5DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M123.028 64.9502C132.564 64.9766 140.441 72.4848 140.441 82.0216C140.441 91.5584 132.564 99.4881 123.028 99.4881C113.491 99.4881 105.719 91.7428 105.745 82.206C105.772 72.6429 113.517 64.8976 123.028 64.9239V64.9502Z",
    fill: "#F7E7E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M123.054 64.977C132.591 65.0033 140.441 72.538 140.441 82.0748C140.441 91.6116 132.591 99.515 123.054 99.515C113.517 99.515 105.745 91.7696 105.772 82.2329C105.798 72.6697 113.543 64.9244 123.054 64.9508V64.977Z",
    fill: "#F8E9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.054 65.003C132.591 65.0293 140.441 72.5639 140.441 82.1007C140.441 91.6374 132.591 99.5409 123.054 99.5409C113.517 99.5409 105.745 91.7955 105.772 82.2587C105.798 72.6956 113.543 64.9503 123.054 64.9766V65.003Z",
    fill: "#F8EBE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M123.08 65.0298C132.617 65.0562 140.468 72.6171 140.468 82.1539C140.468 91.6906 132.643 99.5677 123.08 99.5677C113.517 99.5677 105.772 91.8224 105.798 82.2856C105.825 72.7225 113.57 64.9771 123.08 65.0035V65.0298Z",
    fill: "#F9ECE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M123.08 65.0562C132.617 65.0826 140.441 72.6435 140.441 82.2066C140.441 91.7697 132.617 99.6204 123.08 99.6204C113.543 99.6204 105.798 91.8751 105.798 82.3383C105.798 72.7752 113.57 65.0299 123.08 65.0562Z",
    fill: "#F9EEEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M123.107 65.0825C132.643 65.0825 140.468 72.6961 140.468 82.2329C140.468 91.7696 132.643 99.6204 123.107 99.6204C113.57 99.6204 105.824 91.875 105.824 82.3383C105.824 72.7751 113.596 65.0562 123.107 65.0562V65.0825Z",
    fill: "#FAF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M123.107 65.082C132.643 65.082 140.441 72.722 140.441 82.2588C140.441 91.7955 132.643 99.6462 123.107 99.6462C113.57 99.6462 105.824 91.9009 105.824 82.3641C105.824 72.801 113.596 65.082 123.107 65.082Z",
    fill: "#FBF2EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M123.133 65.1084C132.67 65.1084 140.468 72.7483 140.468 82.2851C140.468 91.8219 132.67 99.6462 123.133 99.6462C113.596 99.6462 105.851 91.9009 105.851 82.3641C105.851 72.801 113.596 65.082 123.133 65.082V65.1084Z",
    fill: "#FBF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M123.159 65.1352C132.696 65.1352 140.494 72.8015 140.494 82.3383C140.494 91.8751 132.722 99.6731 123.159 99.6731C113.596 99.6731 105.877 91.9278 105.877 82.391C105.877 72.8542 113.623 65.1089 123.159 65.1089V65.1352Z",
    fill: "#FCF6F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M123.159 65.1611C132.696 65.1611 140.468 72.8274 140.468 82.3642C140.468 91.901 132.696 99.699 123.159 99.699C113.623 99.699 105.877 91.9537 105.877 82.4169C105.877 72.8801 113.623 65.1348 123.159 65.1348V65.1611Z",
    fill: "#FDF8F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M123.186 65.188C132.722 65.188 140.494 72.8806 140.494 82.4174C140.494 91.9542 132.722 99.7258 123.186 99.7258C113.649 99.7258 105.904 91.9805 105.904 82.4437C105.904 72.9069 113.649 65.1616 123.186 65.1616V65.188Z",
    fill: "#FDF9F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M123.186 65.2138C132.722 65.2138 140.468 72.9065 140.468 82.4433C140.468 91.98 132.722 99.7517 123.186 99.7517C113.649 99.7517 105.904 92.0064 105.904 82.4696C105.904 72.9328 113.649 65.1875 123.186 65.1875V65.2138Z",
    fill: "#FEFBFA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3617_14543",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 241,
    height: 155
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M232.859 0.828125H8.66561C4.29239 0.828125 0.762207 4.35831 0.762207 8.73153V146.409C0.762207 150.782 4.29239 154.312 8.66561 154.312H232.859C237.232 154.312 240.762 150.782 240.762 146.409V8.73153C240.762 4.35831 237.232 0.828125 232.859 0.828125ZM228.96 77.5702C228.96 118.483 195.792 151.678 154.852 151.678H8.66561C5.76769 151.678 3.39667 149.307 3.39667 146.409V8.73153C3.39667 5.83361 5.76769 3.46259 8.66561 3.46259H154.826C195.739 3.46259 228.933 36.6305 228.933 77.5702H228.96Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3617_14543)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3617_14543",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -65,
    width: 286,
    height: 285
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.868 219.936C199.495 219.936 263.234 156.197 263.234 77.5697C263.234 -1.05714 199.495 -64.7969 120.868 -64.7969C42.2407 -64.7969 -21.499 -1.05714 -21.499 77.5697C-21.499 156.197 42.2407 219.936 120.868 219.936Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3617_14543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.955 -116.893L-73.6089 25.4603L68.7446 272.024L315.308 129.67L172.955 -116.893Z",
    fill: "#E04E15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.918 -111.759L-70.645 30.5939L71.7084 277.158L318.272 134.804L175.918 -111.759Z",
    fill: "#E04F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.878 -106.638L-67.6853 35.7151L74.6682 282.279L321.232 139.925L178.878 -106.638Z",
    fill: "#E15015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.829 -101.502L-64.7349 40.8517L77.6186 287.415L324.182 145.062L181.829 -101.502Z",
    fill: "#E15115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.815 -96.3809L-61.748 45.9726L80.6053 292.536L327.169 150.183L184.815 -96.3809Z",
    fill: "#E25215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.752 -91.2471L-58.8113 51.1063L83.5422 297.67L330.106 155.316L187.752 -91.2471Z",
    fill: "#E25316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.739 -86.1001L-55.8242 56.2533L86.5292 302.817L333.093 160.463L190.739 -86.1001Z",
    fill: "#E35416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.703 -80.9663L-52.8606 61.3871L89.4929 307.951L336.056 165.597L193.703 -80.9663Z",
    fill: "#E35516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.663 -75.8184L-49.9006 66.5351L92.4528 313.099L339.016 170.745L196.663 -75.8184Z",
    fill: "#E35616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.613 -70.7075L-46.9504 71.646L95.403 318.209L341.966 175.856L199.613 -70.7075Z",
    fill: "#E45716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.599 -65.5864L-43.9641 76.7671L98.3893 323.331L344.953 180.977L202.599 -65.5864Z",
    fill: "#E45716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.537 -60.4272L-41.0266 81.9263L101.327 328.49L347.89 186.136L205.537 -60.4272Z",
    fill: "#E55816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.523 -55.3062L-38.0403 87.0473L104.313 333.611L350.877 191.257L208.523 -55.3062Z",
    fill: "#E55916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.487 -50.1724L-35.0767 92.1811L107.277 338.745L353.84 196.391L211.487 -50.1724Z",
    fill: "#E55A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.447 -45.0254L-32.116 97.328L110.237 343.892L356.801 201.538L214.447 -45.0254Z",
    fill: "#E65B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.411 -39.8901L-29.1528 102.463L113.201 349.027L359.764 206.673L217.411 -39.8901Z",
    fill: "#E65C17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.384 -34.7925L-26.1794 107.561L116.174 354.124L362.737 211.771L220.384 -34.7925Z",
    fill: "#E75D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.321 -29.6328L-23.2419 112.721L119.112 359.284L365.675 216.931L223.321 -29.6328Z",
    fill: "#E75E17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.308 -24.5117L-20.2559 117.842L122.098 364.405L368.661 222.052L226.308 -24.5117Z",
    fill: "#E85F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.271 -19.3779L-17.292 122.976L125.061 369.539L371.625 227.186L229.271 -19.3779Z",
    fill: "#E86017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.42 -17.4033L-16.1433 124.95L126.21 371.514L372.774 229.16L230.42 -17.4033Z",
    fill: "#E86117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.559 -15.3926L-15.0042 126.961L127.349 373.524L373.913 231.171L231.559 -15.3926Z",
    fill: "#E96217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.708 -13.4185L-13.8555 128.935L128.498 375.498L375.061 233.145L232.708 -13.4185Z",
    fill: "#E96317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.834 -11.4307L-12.7292 130.923L129.624 377.486L376.188 235.133L233.834 -11.4307Z",
    fill: "#E96418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.996 -9.43311L-11.5676 132.92L130.786 379.484L377.349 237.13L234.996 -9.43311Z",
    fill: "#E96518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.148 -7.47119L-10.415 134.882L131.938 381.446L378.502 239.092L236.148 -7.47119Z",
    fill: "#EA6618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.297 -5.49707L-9.26636 136.856L133.087 383.42L379.651 241.066L237.297 -5.49707Z",
    fill: "#EA6718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.423 -3.50928L-8.14014 138.844L134.213 385.408L380.777 243.054L238.423 -3.50928Z",
    fill: "#EA6818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.585 -1.51172L-6.97852 140.842L135.375 387.405L381.938 245.052L239.585 -1.51172Z",
    fill: "#EA6918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.711 0.475586L-5.85229 142.829L136.501 389.392L383.065 247.039L240.711 0.475586Z",
    fill: "#EB6A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.86 2.4502L-4.70361 144.804L137.65 391.367L384.213 249.014L241.86 2.4502Z",
    fill: "#EB6B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.999 4.43506L-3.5647 146.789L138.789 393.352L385.352 250.999L242.999 4.43506Z",
    fill: "#EB6C19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.174 6.40967L-2.3894 148.763L139.964 395.327L386.527 252.973L244.174 6.40967Z",
    fill: "#EB6D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.299 8.39697L-1.26392 150.75L141.09 397.314L387.653 254.96L245.299 8.39697Z",
    fill: "#EC6E19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.462 10.395L-0.101807 152.749L142.252 399.312L388.815 256.958L246.462 10.395Z",
    fill: "#EC6F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.588 12.3823L1.02441 154.736L143.378 401.299L389.941 258.946L247.588 12.3823Z",
    fill: "#EC7019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.737 14.3569L2.17334 156.71L144.527 403.274L391.09 260.92L248.737 14.3569Z",
    fill: "#EC7119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.876 16.3403L3.31226 158.694L145.666 405.257L392.229 262.904L249.876 16.3403Z",
    fill: "#ED7219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.051 18.3149L4.4873 160.668L146.841 407.232L393.404 264.878L251.051 18.3149Z",
    fill: "#ED731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.176 20.3037L5.61304 162.657L147.966 409.221L394.53 266.867L252.176 20.3037Z",
    fill: "#ED741A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.315 22.3145L6.75195 164.668L149.105 411.231L395.669 268.878L253.315 22.3145Z",
    fill: "#ED751A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.465 24.2891L7.90137 166.643L150.255 413.206L396.818 270.853L254.465 24.2891Z",
    fill: "#EE761A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59 26.2764L9.02686 168.63L151.38 415.193L397.944 272.84L255.59 26.2764Z",
    fill: "#EE771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.753 28.2471L10.1892 170.601L152.543 417.164L399.106 274.811L256.753 28.2471Z",
    fill: "#EE781A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.904 30.2344L11.3411 172.588L153.695 419.151L400.258 276.798L257.904 30.2344Z",
    fill: "#EF791A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.053 32.209L12.4897 174.562L154.843 421.126L401.407 278.772L259.053 32.209Z",
    fill: "#EF7A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.192 34.2197L13.6289 176.573L155.982 423.137L402.546 280.783L260.192 34.2197Z",
    fill: "#EF7B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.341 36.1943L14.7776 178.548L157.131 425.111L403.694 282.758L261.341 36.1943Z",
    fill: "#EF7C1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.467 38.1826L15.9038 180.536L158.257 427.1L404.821 284.746L262.467 38.1826Z",
    fill: "#F07D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.63 40.1533L17.0662 182.507L159.42 429.07L405.983 286.717L263.63 40.1533Z",
    fill: "#F07E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.781 42.1411L18.218 184.495L160.571 431.058L407.135 288.705L264.781 42.1411Z",
    fill: "#F07F1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.93 44.1157L19.3667 186.469L161.72 433.033L408.284 290.679L265.93 44.1157Z",
    fill: "#F0801B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.069 46.126L20.5059 188.479L162.859 435.043L409.423 292.689L267.069 46.126Z",
    fill: "#F1801C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.218 48.1006L21.6545 190.454L164.008 437.017L410.571 294.664L268.218 48.1006Z",
    fill: "#F1811C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.344 50.0879L22.7808 192.441L165.134 439.005L411.698 296.651L269.344 50.0879Z",
    fill: "#F1821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.506 52.0601L23.9424 194.414L166.296 440.977L412.859 298.624L270.506 52.0601Z",
    fill: "#F1831C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.658 54.0474L25.095 196.401L167.448 442.964L414.012 300.611L271.658 54.0474Z",
    fill: "#F2841C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.807 56.022L26.2437 198.375L168.597 444.939L415.161 302.585L272.807 56.022Z",
    fill: "#F2851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.946 58.0327L27.3826 200.386L169.736 446.95L416.299 304.596L273.946 58.0327Z",
    fill: "#F2861C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.095 60.0073L28.5315 202.361L170.885 448.924L417.448 306.571L275.095 60.0073Z",
    fill: "#F2871D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.221 61.9946L29.6577 204.348L172.011 450.912L418.575 308.558L276.221 61.9946Z",
    fill: "#F3881D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37 63.9434L30.8064 206.297L173.16 452.86L419.723 310.507L277.37 63.9434Z",
    fill: "#F3891D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.535 65.9541L31.9717 208.308L174.325 454.871L420.889 312.518L278.535 65.9541Z",
    fill: "#F38A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.684 67.9287L33.1206 210.282L175.474 456.846L422.037 314.492L279.684 67.9287Z",
    fill: "#F48B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.81 69.916L34.2466 212.27L176.6 458.833L423.163 316.479L280.81 69.916Z",
    fill: "#F48C1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.972 71.9141L35.4082 214.268L177.762 460.831L424.325 318.478L281.972 71.9141Z",
    fill: "#F48D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.098 73.9014L36.5344 216.255L178.888 462.818L425.451 320.465L283.098 73.9014Z",
    fill: "#F48E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.247 75.8501L37.6831 218.204L180.037 464.767L426.6 322.414L284.247 75.8501Z",
    fill: "#F58F1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.412 77.8608L38.8486 220.214L181.202 466.778L427.765 324.424L285.412 77.8608Z",
    fill: "#F5901E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.561 79.835L39.9973 222.188L182.351 468.752L428.914 326.398L286.561 79.835Z",
    fill: "#F5911E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.686 81.8228L41.123 224.176L183.477 470.74L430.04 328.386L287.686 81.8228Z",
    fill: "#F5921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.849 83.8203L42.2852 226.174L184.639 472.737L431.202 330.384L288.849 83.8203Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.975 85.8076L43.4114 228.161L185.765 474.725L432.328 332.371L289.975 85.8076Z",
    fill: "#F6941E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.123 87.7554L44.5601 230.109L186.913 476.672L433.477 334.319L291.123 87.7554Z",
    fill: "#F6951E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.289 89.7661L45.7256 232.12L188.079 478.683L434.642 336.33L292.289 89.7661Z",
    fill: "#F6961F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.438 91.7402L46.8743 234.094L189.228 480.657L435.791 338.304L293.438 91.7402Z",
    fill: "#F7971F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.563 93.729L47.9998 236.083L190.353 482.646L436.917 340.292L294.563 93.729Z",
    fill: "#F7981F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.726 95.7256L49.1621 238.079L191.516 484.643L438.079 342.289L295.726 95.7256Z",
    fill: "#F7991F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.851 97.7144L50.2876 240.068L192.641 486.631L439.204 344.278L296.851 97.7144Z",
    fill: "#F79A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 99.6621L51.437 242.016L193.79 488.579L440.354 346.226L298 99.6621Z",
    fill: "#F89B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 101.672L52.6025 244.026L194.956 490.589L441.519 348.236L299.166 101.672Z",
    fill: "#F89C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.315 103.647L53.7512 246L196.105 492.564L442.668 350.21L300.315 103.647Z",
    fill: "#F89D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.44 105.634L54.8767 247.988L197.23 494.551L443.794 352.198L301.44 105.634Z",
    fill: "#F89E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.579 107.647L56.0159 250L198.369 496.563L444.933 354.21L302.579 107.647Z",
    fill: "#F99F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.728 109.62L57.1646 251.973L199.518 498.537L446.081 356.183L303.728 109.62Z",
    fill: "#F9A020"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3617_14543",
    x1: 128.323,
    y1: 91.0056,
    x2: 116.363,
    y2: 72.3009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF7F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3617_14543",
    x1: 126.426,
    y1: 90.7685,
    x2: 108.96,
    y2: 56.5995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FF6D00",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5900",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF4800",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF3B00",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3200",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FF2C00",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF2B00",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3617_14543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 155,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiscover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discover.34ac037f1391de8bd0547db02f4ef454.svg";